import * as Function from "../Function";
import * as Error from "../Error";
import { option } from "fp-ts/lib";

export const nullable = (validator: Function.TValidationFunction): Function.TValidationFunction =>
    (value: unknown): option.Option<Error.TValidationError> =>
        value === null
            ? option.none
            : validator(value);
